import { getApi, getBaseApi } from '../../libs/api-client';
import { HttpStatusCode } from '../../types';
import { AttestraConnect } from './AttestraConnectService';

export function createUserSSO(user: any, url: string): Promise<any> {
  return getApi()
    .post<any>(url, user)
    .catch(error => {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        ...error,
        code: error.response.status,
        message: "L'utilisateur n'a pas pu être créé",
      });
    });
}

export function confirmAccountSSO(user: any): Promise<any> {
  return getApi()
    .post<any>('/api/attestra_connect_confirmation_accounts', user)
    .then(response => {
      return response;
    });
}

export function me(): Promise<any> {
  return getApi()
    .get<any>('/api/me')
    .then(response => response.data);
}

export interface AttestraConnectUser {
  sub: string;
  email?: string;
  email_verified?: boolean;
  name?: string;
  given_name?: string;
  family_name?: string;
  [key: string]: unknown;
}

// Utilise getBaseApi() (sans l'intercepteur logout-on-401 de getApi()) :
// au mount, un 401 doit signifier "pas de session" et non déclencher un
// refresh + redirect vers /logout.
export function getAttestraConnectUser(): Promise<AttestraConnectUser> {
  return getBaseApi()
    .get<AttestraConnectUser>('/api/oauth2/user_info_attestra_connect')
    .then(response => response.data);
}

// Variante "silent" : retourne null sur 401 (= pas de session Cognito), throw
// pour le reste. Utilisée pour gater l'appel /api/me au mount du AuthProvider.
export function getAttestraConnectUserSilent(): Promise<AttestraConnectUser | null> {
  return getAttestraConnectUser().catch(error => {
    if (HttpStatusCode.UNAUTHORIZED === error?.response?.status) return null;
    throw error;
  });
}

export function login(): void {
  window.location.href = AttestraConnect.getLoginURL(
    `${origin}/login_callback`,
    `${origin}/login?error=auth_failed`
  );
}

export function logout(): void {
  // returnPath absolu vers le SPA. Doit ÊTRE :
  //   1. dans attestra_connect.allowed_return_origins (côté backend), et
  //   2. dans la liste "Allowed sign-out URLs" du client Cognito (sinon Cognito
  //      redirige vers son /login → "Demande non valide").
  // Pour MDA, /logout_callback est whitelisté côté Cognito (pas /login).
  window.location.href = AttestraConnect.getLogoutURL(`${window.location.origin}/logout_callback`);
}
